import ErrorToast from "@components/Common/ErrorTost";
import { t } from "i18next";
import { toast } from "react-toastify";

// urls.ts
export const getModeOfSaleUrls = ({
    userID,
    shopId,
    franchiseID,
    archived = false,
}: {
    userID: string | number;
    shopId: string | number;
    franchiseID: string | number;
    archived?: boolean;
}) => {
    const base = process.env.REACT_APP_API_V2_URL;

    return archived
        ? `${base}/settings/general/mode_of_sale_archived?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`
        : `${base}/settings/general/mode_of_sale?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}`;
};

export async function isSaleSupportArchived(
    userID: any,
    shopId: any,
    franchiseID: any,
    selectedRows: any,
    i18nextLng: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    toast.dismiss();
    let isSaleSupportArchived = false;
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=archived`;

    try {
        const data = await fetchGlobal<{ data: Array<any> }>(url, {
            method: "GET",
            headers: { "Accept-Language": i18nextLng },
        });

        for (const elt of data.data) {
            for (const element of selectedRows) {
                if (element.support_vente.includes(elt[t("Sale support")])) {
                    isSaleSupportArchived = true;
                    return isSaleSupportArchived;
                }
            }
        }
    } catch (error) {
        ErrorToast(`${t("There's an error")!}`);
    }

    return isSaleSupportArchived;
}
